module.exports = __webpack_public_path__ + "img/g_film_mobile_temp.3033b215.png";